import React, {
  useState,
} from 'react';

import {
  useLocation,
  useNavigate,
} from 'react-router-dom';

import {
  FontAwesomeIcon,
} from '@fortawesome/react-fontawesome';

import {
  faArrowLeft,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

import {
  getContaPrimaraLesson,
} from './data/lessonRegistry.js';

import LeftLessonRenderer from './lessons/LeftLessonRenderer.jsx';
import RightLessonRenderer from './lessons/RightLessonRenderer.jsx';

import './ContaPrimara.css';


const ContaPrimara = () => {
  const navigate = useNavigate();
  const location = useLocation();


  /* =====================================================
     DATE PRIMITE DIN PAGINA CURSULUI
  ===================================================== */

  const {
    unitId,
    lessonId,
    unitTitle,
    lessonTitle,
  } = location.state || {};


  /* =====================================================
     LECTIA CURENTA
  ===================================================== */

  const lesson =
    getContaPrimaraLesson(
      unitId,
      lessonId
    );


  /* =====================================================
     PAS CURENT
  ===================================================== */

  const [
    currentStepIndex,
    setCurrentStepIndex,
  ] = useState(0);


  const totalSteps =
    lesson?.steps?.length || 0;


  const currentStepData =
    lesson?.steps?.[
      currentStepIndex
    ] || null;

    /* =====================================================
   FACTURA CURENTA A LECTIEI
===================================================== */

const currentInvoice =
  lesson?.steps
    ?.map(
      (step) =>
        step?.right?.invoice
    )
    ?.find(Boolean) ||
  null;


  /* =====================================================
     PROGRES
  ===================================================== */

  const progress =
    totalSteps > 0
      ? (
          (
            currentStepIndex + 1
          ) /
          totalSteps
        ) * 100
      : 0;


  /* =====================================================
     INAPOI
  ===================================================== */

  const handleBack = () => {
    if (
      currentStepIndex > 0
    ) {
      setCurrentStepIndex(
        (prev) => prev - 1
      );
    }
  };


  /* =====================================================
     CONTINUA
  ===================================================== */

  const handleNext = () => {
    if (
      currentStepIndex <
      totalSteps - 1
    ) {
      setCurrentStepIndex(
        (prev) => prev + 1
      );

      return;
    }

    console.log(
      'Lectia a fost finalizata'
    );

    navigate(
      '/functionalpagelogin'
    );
  };


  /* =====================================================
     IESIRE
  ===================================================== */

  const handleExit = () => {
    navigate(
      '/functionalpagelogin'
    );
  };


  /* =====================================================
     PROTECTIE - NU EXISTA DATE DE NAVIGARE
  ===================================================== */

  if (
    !unitId ||
    !lessonId
  ) {
    return (
      <div className="conta-primara-page">

        <div className="conta-primara-loading">

          <p>
            Lectia nu a fost selectata.
          </p>

          <button
            type="button"
            onClick={handleExit}
          >
            Inapoi la curs
          </button>

        </div>

      </div>
    );
  }


  /* =====================================================
     PROTECTIE - LECTIA NU EXISTA IN REGISTRY
  ===================================================== */

  if (
    !lesson ||
    !currentStepData
  ) {
    return (
      <div className="conta-primara-page">

        <div className="conta-primara-loading">

          <p>
            Lectia nu a putut fi incarcata.
          </p>

          <button
            type="button"
            onClick={handleExit}
          >
            Inapoi la curs
          </button>

        </div>

      </div>
    );
  }


  /* =====================================================
     RENDER
  ===================================================== */

  return (
    <div className="conta-primara-page">


      {/* =================================================
          HEADER
      ================================================= */}

      <header className="conta-primara-header">


        <button
          type="button"
          className="conta-primara-exit"
          onClick={handleExit}
          aria-label="Inapoi la curs"
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
          />
        </button>


        <div className="conta-primara-header-title">

          <span>
            {
              unitTitle ||
              'Contabilitate primara'
            }
          </span>

          <strong>
            {
              lessonTitle ||
              lesson.title
            }
          </strong>

        </div>


        <div className="conta-primara-progress">

          <div
            className="conta-primara-progress-fill"
            style={{
              width: `${progress}%`,
            }}
          />

        </div>

      </header>


      {/* =================================================
          WORKSPACE
      ================================================= */}

      <main className="conta-primara-workspace">


        {/* STANGA */}

        <section className="conta-primara-lesson">

          <div className="conta-primara-lesson-scroll">

            <LeftLessonRenderer
              content={
                currentStepData.left
              }
              lesson={lesson}
              step={
                currentStepData
              }
            />

          </div>

        </section>


        {/* DREAPTA */}

        <section className="conta-primara-interactive">

          <div className="conta-primara-interactive-header">

            {
              currentStepData
                .right
                ?.header ||
              'Activitate'
            }

          </div>


          <div className="conta-primara-interactive-content">

     <RightLessonRenderer
  content={
    currentStepData.right
  }
  lesson={lesson}
  step={
    currentStepData
  }
  invoice={
    currentInvoice
  }
/>



          </div>

        </section>

      </main>


      {/* =================================================
          FOOTER
      ================================================= */}

      <footer className="conta-primara-bottom-bar">


        <button
          type="button"
          className="conta-primara-nav-btn"
          onClick={handleBack}
          disabled={
            currentStepIndex === 0
          }
        >
          <FontAwesomeIcon
            icon={faChevronLeft}
          />

          Inapoi
        </button>


        <div className="conta-primara-step">

          {currentStepIndex + 1}
          {' / '}
          {totalSteps}

        </div>


        <button
          type="button"
          className="
            conta-primara-nav-btn
            conta-primara-nav-btn-next
          "
          onClick={handleNext}
        >
          {
            currentStepIndex ===
            totalSteps - 1
              ? 'Finalizeaza'
              : 'Continua'
          }

          <FontAwesomeIcon
            icon={faChevronRight}
          />
        </button>

      </footer>

    </div>
  );
};


export default ContaPrimara;